import { render, staticRenderFns } from "./SchemaContentItem.vue?vue&type=template&id=8da4ccd0&scoped=true"
import script from "./SchemaContentItem.vue?vue&type=script&lang=js"
export * from "./SchemaContentItem.vue?vue&type=script&lang=js"
import style0 from "./SchemaContentItem.vue?vue&type=style&index=0&id=8da4ccd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da4ccd0",
  null
  
)

export default component.exports